module.exports = __webpack_public_path__ + "img/chemical-plant.7fe8f271.png";